export default __webpack_public_path__ + "static/media/NASA_05.ca28ba69.png";